import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';


// const endpoint = environment.apiUrl;
// const endpointP = environment.apiProcessorUrl;
const endpoint = environment.apiBaseUrl + '/asistente/chat';
const endpointP = environment.apiBaseUrl + '/asistente';
const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

@Injectable({
  providedIn: 'root'
})
export class ChatService {

  constructor(private http: HttpClient) { }

  private extractData(res: Response) {
    const body = res;
    return body || {};
  }

  askForHandler(ctx): Observable<any> {
    //console.log("askForHanlder():: context: %s", JSON.stringify(ctx));
    return this.http.post<any>(endpointP + '/askForHandler', JSON.stringify(ctx),
      httpOptions).pipe(map(this.extractData)
      );
  }

  getIniciarChat(ctx): Observable<any> {
    //debugger
    return this.http.post<any>(endpoint + '/iniciarChat', JSON.stringify(ctx),
      httpOptions).pipe(map(this.extractData)
      );
  }

  getConsultarCola(ctx): Observable<any> {
    return this.http.post<any>(endpoint + '/consultarCola', JSON.stringify(ctx),
      httpOptions).pipe(map(this.extractData)
      );
  }

  enviarMensaje(req): Observable<any> {
    //console.log("enviarMensaje():: request: %s", JSON.stringify(req));
    return this.http.post<any>(endpoint + '/enviarMensaje', JSON.stringify(req),
      httpOptions).pipe(
        catchError(this.handleError<any>('enviarMensaje'))
      );
  }

  actualizarChat(req): Observable<any> {
    return this.http.post<any>(endpoint + '/actualizarChat', JSON.stringify(req),
      httpOptions).pipe(
        catchError(this.handleError<any>('actualizarChat'))
      );

  }

  finalizarChat(req): Observable<any> {
    //console.log("finalizarChat():: request: %s", JSON.stringify(req));
    return this.http.post<any>(endpoint + '/finalizarChat', '{"participantID":"' + req + '"}',
      httpOptions).pipe(
        catchError(this.handleError<any>('finalizarChat'))
      );
  }

  enviarEscribiendo(req): Observable<any> {
    return this.http.post<any>(endpoint + '/escribiendoChat/' + req.participantID, '{"typingIndicator":"' + req.indicador + '"}',
      httpOptions).pipe(
        catchError(this.handleError<any>('escribiendoChat'))
      );
  }

  estadoChat(req): Observable<any> {
    return this.http.post<any>(endpoint + '/status', JSON.stringify(req),
      httpOptions).pipe(
        catchError(this.handleError<any>('estadoChat'))
      );
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.log(`operation: ${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
